// src/pages/ManageBankHolidaysPage.js

import React, { useEffect, useState } from 'react';
import Calendar from 'rc-year-calendar'; 
import 'rc-year-calendar/locales/rc-year-calendar.es';
import dayjs from 'dayjs';
import { fetchBankHolidays, addBankHoliday, removeBankHoliday } from '../api/bankHolidays';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Snackbar } from '@mui/material';


function ManageBankHolidaysPage() {
  const [year, setYear] = useState(new Date().getFullYear());
  const [bankHolidays, setBankHolidays] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const loadBankHolidays = async () => {
      try {
        const data = await fetchBankHolidays(year);
        setBankHolidays(data.bank_holidays || []);
      } catch (err) {
        setSnackbar({ open: true, message: err.message, severity: 'error' });
      }
    };
    
    loadBankHolidays();
  }, [year]); 

  // Convert bankHolidays into rc-year-calendar's dataSource format
  const dataSource = bankHolidays.map((dateString) => ({
    startDate: new Date(dateString),
    endDate: new Date(dateString),
    color: 'lightgray',
  }));

  // Handle a click on a day cell
  const handleDayClick = async ({ date, events }) => {
    const dateStr = dayjs(date).format('YYYY-MM-DD');

    if (events.length > 0) {
      try {
        const data = await removeBankHoliday(dateStr);
        setBankHolidays(data.bank_holidays || []);
      } catch (err) {
        setSnackbar({ open: true, message: err.message, severity: 'error' });
      }
    } else {
      try {
        const data = await addBankHoliday(dateStr);
        setBankHolidays(data.bank_holidays || []);
      } catch (err) {
        setSnackbar({ open: true, message: err.message, severity: 'error' });
      }
    }
  };

  // Called when the user changes the year in the UI
  const handleYearChanged = (e) => {
    setYear(e.currentYear);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4">{t('holidays.manage_holidays')}</Typography>
      <Box sx={{ mt: 2 }}>
        <Calendar
          year={year} 
          disabledWeekDays={[6,0]}
          dataSource={dataSource}
          onDayClick={handleDayClick}
          onYearChanged={handleYearChanged}
          language={i18n.language}
          // eslint-disable-next-line
          style={"background"} 
          weekStart={1}
        />
        </Box>
        <Snackbar
            open={snackbar.open}
            message={snackbar.message}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
        />
    </Box>
  );
}

export default ManageBankHolidaysPage;
